.overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  cursor: default;
}

.selection {
  position: absolute;
  border: 1px solid var(--color-accent-primary);
  background: color-mix(in srgb, var(--color-accent-primary) 12%, transparent);
  pointer-events: none;
}
